import { BuildConfig } from '@common/util-models';
import { fromEvent } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { BuildConfigService } from '../../services';
import { checkUpdatedActiveCookieCategories } from '../cookie/cookie-helpers.util';

export const cookieProInitializer =
  (
    document: Document,
    buildConfigService: BuildConfigService
  ): (() => Promise<Event | undefined>) =>
  () => {
    return buildConfigService.config$
      .pipe(
        mergeMap((config: BuildConfig) => {
          const head = document.head;

          if (config.cookiePro?.autoBlockScript) {
            const autoBlockScript: HTMLScriptElement =
              document.createElement('script');
            autoBlockScript.src = config.cookiePro?.autoBlockScript;
            head.insertBefore(autoBlockScript, head.childNodes[0]);
          }

          const script: HTMLScriptElement = document.createElement('script');
          if (config.cookiePro) {
            script.src = config.cookiePro.src;
            script.setAttribute(
              'data-domain-script',
              config.cookiePro.domainScript
            );
          } else {
            script.src = config.cookieProSrc;
            script.setAttribute(
              'data-domain-script',
              config.cookieProDomainScript
            );
          }
          script.setAttribute('data-document-language', 'true');

          head?.insertBefore(script, head.childNodes[0]);

          let currentCookieCategories: string[] = [];
          (window as any).OptanonWrapper = () => {
            if (config.cookiePro) {
              // OptanonWrapper executes on app load, and on every change of cookie consent
              const activeCookieCategories = (
                window as any
              ).OnetrustActiveGroups.split(',').filter((g: string) => g);
              currentCookieCategories = checkUpdatedActiveCookieCategories(
                currentCookieCategories,
                activeCookieCategories
              );
            }
          };

          return fromEvent(script, 'load');
        }),
        first()
      )
      .toPromise();
  };
